import { NestedStyles } from 'Shared/backend/styleUtils';
import { navStyles } from 'Shared/frontend/styles/navStyles';
import { textStyles } from 'Shared/frontend/styles/textStyles';
import { layoutStyles } from 'Shared/frontend/styles/layoutStyles';
import { transitionsStyles } from 'Shared/frontend/styles/transitionsStyles';
import { customStyles } from 'Shared/frontend/styles/customStyles';
import { overlayStyles } from 'Shared/frontend/styles/overlayStyles';
import { footerStyles } from 'Shared/frontend/styles/footerStyles';
import { toolStyles } from 'Shared/frontend/styles/toolStyles';
import { specificPageStyles } from './specificPageStyles';


export function standardStyles(sizes,text): NestedStyles
{
	return {
		layout: layoutStyles(sizes,text),
		text: textStyles(sizes,text),
		transitions: transitionsStyles(sizes,text),

		/* By component: */
		overlays: overlayStyles(sizes,text),

		/* By page: */
		'For specific pages': specificPageStyles(sizes,text),

		/* Headers, footers: */
		nav: navStyles(sizes,text),
		footers: footerStyles(sizes,text),

		tools: toolStyles(sizes,text),
		custom: customStyles(sizes,text),
	};
}

